import { useAppDispatch, useAppSelector } from "../../../../utils/hooks";
import { useTheme } from "../../../../context/ThemeProvider";
import { useFile } from "../../../../context/FileProvider";
import { RxCross2 } from "react-icons/rx";
import { updateSendMessageData } from "../../../../store/Slices/SendMessageSlice";
import ShowReplyMessage from "./ShowReplyMessage";

export default function SelectedReplyMessage() {
  const dispatch = useAppDispatch();
  const messageData = useAppSelector((state) => state.SendMessageData);
  const MessageListArray = useAppSelector((state) => state.MessageList);
  const SendMessageData = useAppSelector((state) => state.SendMessageData);
  const { selectedFile, chatAttachments } = useFile();

  const hasComposeMediaStrip =
    chatAttachments.length > 0 ||
    (SendMessageData.message_type === "gif" &&
      !!SendMessageData.message?.trim()) ||
    (["image", "video", "gif", "doc"].includes(SendMessageData.message_type!) &&
      selectedFile);

  // @ts-ignore
  const { theme } = useTheme();
  const repliedMessage = MessageListArray.message_list?.Records?.find(
    (message) => message.message_id == messageData.reply_to,
  );

  const open = messageData.reply_to != 0;

  return (
    <div
      className={`${
        open
          ? "visible translate-y-3"
          : "pointer-events-none invisible translate-y-20 opacity-0"
      } absolute ${hasComposeMediaStrip ? "bottom-64" : "bottom-16"} left-2 right-2 z-10 overflow-hidden rounded-2xl border bg-primary transition-all duration-500 ${
        theme === "dark" ? "border-[#EEEEEE14]" : "border-black/[0.06]"
      }`}
    >
      <div className="relative flex min-h-[52px] min-w-0 items-stretch">
        <div
          className="my-2.5 ml-2.5 w-[3px] shrink-0 self-stretch rounded-full bg-themeColor"
          aria-hidden
        />
        <RxCross2
          onClick={() => {
            dispatch(
              updateSendMessageData({
                reply_to: 0,
              }),
            );
          }}
          className="absolute right-2 top-1/2 z-10 h-8 w-8 -translate-y-1/2 cursor-pointer rounded-full bg-secondary p-2"
        />
        <div className="min-w-0 flex-1 pr-12">
          <ShowReplyMessage
            reply_to={messageData.reply_to!}
            messageData={repliedMessage!}
            variant="compose"
          />
        </div>
      </div>
    </div>
  );
}
